<!-- 解除停售列表 -->
<template>
  <div class='page_content'>
    <removeStopSellingAction ref="removeStopSellingAction"></removeStopSellingAction>
    <subComponents ref="showSelectData"></subComponents>

    <div class="page_content_top">
      <div class="page_content_top_line">
        <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
          {{buttonValue.jurName}}
        </el-button>
        <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getDataList()">
          刷新
        </el-button>
      </div>
      <div class="page_content_top_line">
        <el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
          <el-form-item v-if="formOneValue.isShow==1" :label="formOneValue.showField"  v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
              <el-input v-if="formOneValue.entityField == 'bgmId'" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList','bgmId','bgmId')" v-model="getRequestData.bgmName" maxlength="64">
            </el-input>
            <el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
            type="date" placeholder="选择日期">
            </el-date-picker>
            <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
            type="date" placeholder="选择日期"></el-date-picker>
            <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" maxlength="64"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" v-if="pageShowData[1]" stripe :data="returnData.list" height="100%" border style="width: 100%" highlight-current-row>
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column   show-overflow-tooltip :min-width="tableValye.fieldWeight" v-if="tableValye.isShow==1"
        v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
              <template   slot="header">
                <div>
                    <el-tooltip :content="tableValye.showField" placement="top">
                        <div class="long_title"><span>{{tableValye.showField}}</span></div>
                    </el-tooltip>
                </div>
            </template>
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
                <span v-if="scope.row[tableValye.entityField]">
                    {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
            </span>
            <span v-else-if="tableValye.entityField == 'rsmState'">
              <el-tag size="mini" type="primary">{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</el-tag>
            </span>
            <span v-else>
              {{scope.row[tableValye.entityField]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
        layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import removeStopSellingAction from '@/components/removeStopSellingAction.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
	removeStopSellingAction,
	},
  data() {
    //这里存放数据
    return {
      getRequestData: {
        bgmId: "",
        bgmName: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,

      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },

      buttonList: [],

      selectedDataIndex: 0,
      pageShowData: [],

      formDataList: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.bgmName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.bgmId = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
      changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },

        // 点击穿透字段 传参单号
        toDetail(orderId) {
           if (orderId) {
               // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {isPenetrate} //参数
                }, '*');
           }
        },
    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, "");
        let arr = JSON.parse(str);
        let len = arr.length;
        let newStr = "";
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value;
            break;
          }
        }
        return newStr;
      } catch (ex) {
        return str;
      }
    },
    isShowData(name, value) {
      switch (name) {
        case "bgmId":
          var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.bgmId = dataInfo.bgmId;
            this.getRequestData.bgmName = dataInfo.bgmName;
          }

          break;

        default:
          this.getRequestData[name] = value;
      }
    },
    getPageInfo() {
      var ss = parent.getMenuInfo(this.$route.path);
      this.getDataTest(ss.jurId);
    },

    // 获取数据列表
    async getDataTest(ids) {
      let responseData = await this.$http.pageFormText({ ids: [ids] });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        if (this.pageShowData[2]) {
          this.formDataList = this.pageShowData[2];
        }
        console.log(responseData.result);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.$refs["removeStopSellingAction"].openBox(
            0,
            this.formDataList,
            ""
          );
          break;
        case 1:
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.$refs["removeStopSellingAction"].openBox(
            1,
            this.formDataList,
            dataInfo
          );
          break;
        case 2:
          this.delDataAction();
          break;
        case 3:
          this.submitData();
          break;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
        if (this.getRequestData.end != '') this.getRequestData.end = this.getRequestData.end+24*60*60*1000-1
        let responseData = await this.$http.getRemoveStopSellingList(
            this.getRequestData
        );
        if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
        } else {
            this.$message({
            message: responseData.message,
            type: "error",
            });
        }
    },

    // 删除数据
    delDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [dataInfo.rsmId],
          };
          let responseData = await this.$http.delRemoveStopSelling(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交审核
    submitData() {
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      this.$confirm("确定要提交审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            businessKey: dataInfo.rsmId,
          };
          let responseData = await this.$http.submitRemoveStopSelling(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => {});
    },

    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo();
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  scoped>
.table_content_tag {
  margin-right: 1rem;
}
.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
